export default "__VITE_ASSET__f2969602__"